import debounce from 'lodash/debounce';
import { GoogleMaps } from '../components/GoogleMaps';

class Shops {
    constructor(section = null) {
        if (!section) return;
        this.root = section;

        this.init();
    }

    init() {
        this.loader = this.root.querySelector('.loader');
        this.checkboxes =
            this.root.querySelectorAll('input[name="shop_type"]') ?? [];
        this.jsOutput = this.root.querySelector('[js-content]');

        this.page = 1;
        this.onlineShopsPerPage = window.innerWidth >= 1024 ? 6 : 2;
        this.isDesktopView = window.innerWidth > 1023.98;
        this.phrase = '';
        this.activeType = Array.from(this.checkboxes).find(
            item => item.checked
        )?.value;
        this.events();
        this.fetchDebounced = debounce((...args) => this.fetch(...args), 300);

        this.mapInstance = null;
    }

    events() {
        this.checkboxes.forEach(checkbox => {
            checkbox.addEventListener(
                'change',
                this.onCheckboxChange.bind(this)
            );
        });

        window.addEventListener(
            'accordion:change',
            this.onAccordionChange.bind(this)
        );
        window.addEventListener('resize', this.onWindowResize.bind(this));
        window.addEventListener(
            'click',
            this.onPaginationButtonClick.bind(this)
        );
        window.addEventListener('input', this.onPhraseFormInput.bind(this));
        window.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    onWindowResize() {
        const width = window.innerWidth;
        if (width > 1023.98 && !this.isDesktopView) {
            this.onlineShopsPerPage = 6;
            this.isDesktopView = true;
        } else if (width <= 1023.98 && this.isDesktopView) {
            this.onlineShopsPerPage = 2;
            this.isDesktopView = false;
        } else {
            return;
        }

        if (this.activeType !== 'nowodvorski-shop') {
            this.page = 1;
            this.fetch();
        }
    }

    onCheckboxChange(e) {
        this.activeType = e.target.value;

        if (this.activeType === 'online-shop') {
            this.onlineShopsPerPage = window.innerWidth >= 1024 ? 6 : 2;
        }
        this.phrase = '';
        this.page = 1;
        this.fetch();
    }

    onAccordionChange(e) {
        const { element, opened } = e.detail;
        if (!opened || !this.mapWrapper) return;
        const accordionId = element.dataset.id;
        if (!accordionId || !this.mapInstance.markers.length) return;

        this.mapInstance.goToMarker(accordionId);
    }

    onPhraseFormInput(e) {
        const { target } = e;
        const form = target.closest('[js-phrase-form]');
        if (!form) return;

        const { value } = target;

        this.phrase = value;
        this.page = 1;
        this.fetchDebounced(
            true,
            this.root.querySelector('[js-shops-right-column]'),
            true,
            true
        );
    }

    onFormSubmit(e) {
        const { target } = e;
        const form = target.closest('[js-phrase-form]');
        if (!form) return;

        e.preventDefault();
    }

    async onPaginationButtonClick(e) {
        const { target } = e;
        let button = null;
        let htmlDataAttribute = null;
        if (target.closest('.js-online-shop-pagination-button')) {
            button = target;
            htmlDataAttribute = 'js-online-shops-list';
        } else if (target.closest('.js-shop-pagination-button')) {
            button = target;
            htmlDataAttribute = 'js-shops-list';
        } else {
            return;
        }
        const paginationElement = button.closest('[js-pagination]');
        const buttonWrapper = button.closest('[js-pagination-button-wrapper]');
        if (!paginationElement || !buttonWrapper) return;

        this.page = this.page + 1;
        await this.fetch(
            false,
            document.querySelector(`[${htmlDataAttribute}]`)
        );
        const current = paginationElement.querySelector('[js-current]');
        const progressBar =
            paginationElement.querySelector('[js-progress-bar]');

        const totalElement = parseInt(
            paginationElement.getAttribute('data-total')
        );
        const elements = this.root.querySelectorAll(
            this.activeType === 'online-shop'
                ? '[js-online-shop-box]'
                : '[js-shop-accordion-element]'
        );

        current.textContent = elements.length;
        progressBar.style.width = `${(elements.length / totalElement) * 100}%`;

        paginationElement.setAttribute('data-page', this.page);
        if (this.page == paginationElement.getAttribute('data-max-pages')) {
            buttonWrapper.classList.add('hidden');
        } else {
            buttonWrapper.classList.remove('hidden');
        }
    }

    async fetch(
        replaceContent = true,
        htmlOutput = this.jsOutput,
        isFocus = false,
        withoutMapRefresh = false
    ) {
        try {
            this.loader.classList.add('active');
            const formData = new FormData();
            formData.append('action', 'fetch_shops_content');
            formData.append('phrase', this.phrase);
            formData.append('type', this.activeType);
            formData.append('page', this.page);
            formData.append('onlineShopsPerPage', this.onlineShopsPerPage);
            if (withoutMapRefresh) {
                formData.append('onlyRightColumn', true);
            }
            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });
            const res = await req.json();
            if (replaceContent) {
                htmlOutput.innerHTML = res.html;
            } else {
                htmlOutput.innerHTML += res.html;
            }

            this.mapWrapper =
                this.activeType === 'shop'
                    ? this.root.querySelector('[js-map-wrapper]')
                    : null;

            if (this.mapWrapper && this.page == 1) {
                const accordionElements = this.root.querySelectorAll(
                    '[js-shop-accordion-element]'
                );
                const first = accordionElements.length
                    ? accordionElements[0].getAttribute('data-id')
                    : null;
                if (withoutMapRefresh) {
                    this.mapInstance.goToMarker(first);
                } else {
                    this.mapInstance = new GoogleMaps(this.mapWrapper);
                    this.mapInstance.initMap(first);
                }
            }

            if (isFocus) {
                const input = this.root.querySelector('[name="phrase"]');
                if (input) {
                    input.focus();
                    input.setSelectionRange(
                        input.value.length,
                        input.value.length
                    );
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.loader.classList.remove('active');
        }
    }
}

const sections = document.querySelectorAll('section.shops');
sections.forEach(section => {
    const shops = new Shops(section);
});
